document.addEventListener('DOMContentLoaded', () => {
	const tabsContainers = document.querySelectorAll('.wp-block-knightowl-blocks-tabs-loop');

	tabsContainers.forEach(tabsContainer => {
		const parentUL = tabsContainer.querySelector('ul');
		const tabs = Array.from(tabsContainer.querySelectorAll('.tabs-title a'));
		const navButtons = tabsContainer.querySelector('.tabs-navigation');
		const selectDropdown = tabsContainer.querySelector('.tabs-dropdown-menu-mobile');
		const autoplay = navButtons && navButtons.getAttribute('data-auto-play') === 'true';
		const autoplaySpeed = navButtons ? parseInt(navButtons.getAttribute('data-auto-play-speed'), 10) || 3000 : 3000;
		const prevButton = navButtons ? navButtons.querySelector('.previous-tab') : null;
		const nextButton = navButtons ? navButtons.querySelector('.next-tab') : null;

		let currentTabIndex = tabs.findIndex(tab => tab.parentElement.classList.contains('is-active'));
		let autoplayInterval;

		if (selectDropdown) {
			selectDropdown.value = `#panel-${currentTabIndex}`;
		}

		// Function to activate a tab based on index
		const activateTab = (index) => {
			const prevActiveContent = tabsContainer.querySelector('.tabs-item.is-active');
			const prevActiveTab = parentUL.querySelector('.tabs-title.is-active');

			if (prevActiveContent) {
				prevActiveContent.classList.remove('is-active');
				prevActiveContent.setAttribute('aria-hidden', 'true');
				prevActiveTab.classList.remove('is-active');
				prevActiveTab.setAttribute('aria-selected', 'false');
			}

			const newActiveContent = tabsContainer.querySelector(`.tabs-item[data-id="panel-${index}"]`);
			const newActiveTab = tabs[index].parentElement;

			newActiveContent.classList.add('is-active');
			newActiveContent.setAttribute('aria-hidden', 'false');
			newActiveTab.classList.add('is-active');
			newActiveTab.setAttribute('aria-selected', 'true');

			currentTabIndex = index;

			// Update the select dropdown if it exists
			if (selectDropdown) {
				selectDropdown.value = `#panel-${index}`;
			}
		};

		// Event listener for tab clicks
		parentUL.addEventListener('click', (event) => {
			event.preventDefault();

			const link = event.target.closest('.tabs-title > a');
			if (!link) return; // Exit if the clicked element is not a tab link

			const index = tabs.findIndex(tab => tab === link);
			activateTab(index);
		});

		// Only apply dropdown logic if the 'has-dropdown-menu-mobile' class exists
		if (tabsContainer.classList.contains('has-dropdown-menu-mobile')) {
			// Event listener for select dropdown change
			if (selectDropdown) {
				selectDropdown.addEventListener('change', (event) => {
					const targetHref = event.target.value;
					const index = tabs.findIndex(tab => tab.getAttribute('href') === targetHref);
					activateTab(index);
				});
			}
		}

		// Function to switch tabs based on direction ('prev' or 'next')
		const switchTab = (direction) => {
			// Calculate the new tab index based on the direction and loop around if necessary
			if (direction === 'next') {
				currentTabIndex = (currentTabIndex + 1) % tabs.length;
			} else if (direction === 'prev') {
				currentTabIndex = (currentTabIndex - 1 + tabs.length) % tabs.length;
			}
			activateTab(currentTabIndex);
		};

		// Autoplay functionality
		const startAutoplay = () => {
			if (autoplay) {
				autoplayInterval = setInterval(() => {
					switchTab('next');
				}, autoplaySpeed);
			}
		};

		// Stop autoplay when mouse enters the tabs container and resume when it leaves
		const stopAutoplay = () => {
			clearInterval(autoplayInterval);
		};

		// Initialize autoplay if enabled and navigation buttons are present
		if (autoplay && (prevButton || nextButton)) {
			startAutoplay();
			tabsContainer.addEventListener('mouseenter', stopAutoplay);
			tabsContainer.addEventListener('mouseleave', startAutoplay);
		}

		// Adding click event listeners to navigation buttons if they exist
		if (prevButton) {
			prevButton.addEventListener('click', () => switchTab('prev'));
		}
		if (nextButton) {
			nextButton.addEventListener('click', () => switchTab('next'));
		}
	});
});
